<template>
	<div class="m-banner">
		<div v-for="(item, i) in bannerList" :key="i" class="item" :class="{'z-crt': i == currentBanner}">
			<a>
				<c-image class="image" :src="item.img_url" mode="aspectFill"></c-image>
			</a>
		</div>
		
		<div class="nav">
			<div v-for="(item, i) in bannerList" :key="i" class="item" :class="{'z-crt': i == currentBanner}"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentBanner: 0,
				bannerList: []
			}
		},
		
		mounted() {
		},
		
		methods: {
			set(data) {
				this.bannerList = data.list;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-banner {
		position: relative;
		height: 335px;
		margin: 10px 10px 0;
		overflow: hidden;
		
		> .item {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			height: 335px;
			border-radius: 6px;
			overflow: hidden;
			opacity: 0;
			transition: opacity .3s ease;
			
			&.z-crt {
				z-index: 1;
				opacity: 1;
			}
			
			.image {
				height: 335px;
			}
		}
		
		.nav {
			z-index: 1;
			position: absolute;
			left: 50%;
			bottom: 10px;
			font-size: 0;
			transform: translate(-50%,0);
			
			.item {
				display: inline-block;
				width: 5px;
				height: 5px;
				border-radius: 3px;
				margin: 0 7px;
				background: #ccc;
				
				&.z-crt {
					width: 20px;
					background: #DE1B24;
				}
			}
		}
	}
</style>
